import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IPagination } from 'src/app/shared/models/pagination';
import FilterValues from '../interfaces/ip-filter-values';

@Injectable({
  providedIn: 'root',
})
export class QueryParametersService {
  buildQueryParameters(
    sortFieldName: string | string[],
    sortOrder: string | string[],
    pagination: IPagination,
    searchName: string,
    searchValue: string,
    filterValues?: FilterValues,
    statusId?: number,
    ignoredTypeStatus?: number,
    statusCode?: string,
    billed?: boolean,
    supplierId?: number,
    notInSettlement?: boolean,
    isPaid?: boolean,
    saleIdName?: string,
    allEnterpriseInvoices?: boolean
  ): HttpParams {
    const queryParameters: { [param: string]: any } = {
      page: pagination.page,
      size: pagination.size,
    };
    if (
      sortFieldName &&
      typeof (sortFieldName) === 'string' &&
      sortFieldName.trim() !== '' &&
      sortOrder &&
      typeof (sortOrder) === 'string' &&
      sortOrder.trim() !== ''
    ) {
      queryParameters['sort'] = `${sortFieldName},${sortOrder}`;
    }
    if (
      sortFieldName &&
      Array.isArray(sortFieldName) &&
      sortOrder &&
      Array.isArray(sortOrder) &&
      sortFieldName.length === sortOrder.length
    ) {
      let sort: string[] = [];
      for (let i = 0; i < sortFieldName.length; i++) {
        sort.push(`${sortFieldName[i]},${sortOrder[i]}`)
      }
      queryParameters['sort'] = sort;
    }
    if (searchName && searchName.trim() !== '' && searchValue.trim() !== '') {
      queryParameters[searchName] = searchValue;
    }
    if (filterValues) {
      if (filterValues.amountFrom !== undefined) {
        queryParameters['amountFrom'] = filterValues.amountFrom;
      }
      if (filterValues.amountTo !== undefined) {
        queryParameters['amountTo'] = filterValues.amountTo;
      }
      //TODO fechas
      if (filterValues.createDateFrom && filterValues.createDateTo) {
        queryParameters['createDateFrom'] = filterValues.createDateFrom;
        queryParameters['createDateTo'] = filterValues.createDateTo;
      }
      if (filterValues.createDateFrom !== undefined) {
        queryParameters['createDateFrom'] = filterValues.createDateFrom;
      }
      if (filterValues.createDateTo !== undefined) {
        queryParameters['createDateTo'] = filterValues.createDateTo;
      }
      if (filterValues.loadingDateFrom !== undefined) {
        queryParameters['loadingDateFrom'] = filterValues.loadingDateFrom;
      }
      if (filterValues.loadingDateTo !== undefined) {
        queryParameters['loadingDateTo'] = filterValues.loadingDateTo;
      }
      if (filterValues.brokersId !== undefined) {
        queryParameters['brokersId'] = filterValues.brokersId;
      }
      if (filterValues.productTypeIds !== undefined) {
        queryParameters['productTypeIds'] = filterValues.productTypeIds;
      }
      if (filterValues.fiscalId !== undefined) {
        queryParameters['fiscalId'] = filterValues.fiscalId;
      }
    }
    // For bills:
    if (statusId) {
      queryParameters['statusId'] = statusId;
    }
    if (supplierId) {
      queryParameters['supplierId'] = supplierId;
    }
    if (ignoredTypeStatus) {
      queryParameters['ignoreStatusId'] = ignoredTypeStatus;
    }
    // For settlements:
    if (statusCode) {
      queryParameters['statusCode'] = statusCode;
    }
    if (filterValues?.status !== undefined) {
      queryParameters['statusCode'] = filterValues.status;
    }
    if (filterValues?.statusIds !== undefined) {
      queryParameters['statusIds'] = filterValues.statusIds;
    }
    if (filterValues?.periodId !== undefined) {
      queryParameters['periodId'] = filterValues.periodId;
    }
    if (billed !== undefined) {
      queryParameters['billed'] = billed;
    }
    if (notInSettlement !== undefined) {
      queryParameters['notInSettlement'] = notInSettlement;
    }
    if (isPaid !== undefined) {
      queryParameters['isPaid'] = isPaid;
    }
    if (saleIdName !== undefined && saleIdName !== null) {
      queryParameters['saleIdName'] = saleIdName;
    }
    if (allEnterpriseInvoices) {
      queryParameters['allEnterpriseInvoices'] = allEnterpriseInvoices;
    }
    return new HttpParams({ fromObject: queryParameters });
  }

  buildQueryParametersByFilterValues(
    filterValues?: FilterValues
  ): HttpParams {
    let queryParameters: { [param: string]: any } = {};
    if (filterValues) {
      if (filterValues.amountFrom !== undefined) {
        queryParameters['amountFrom'] = filterValues.amountFrom;
      }
      if (filterValues.amountTo !== undefined) {
        queryParameters['amountTo'] = filterValues.amountTo;
      }
      //TODO fechas
      if (filterValues.createDateFrom && filterValues.createDateTo) {
        queryParameters['createDateFrom'] = filterValues.createDateFrom;
        queryParameters['createDateTo'] = filterValues.createDateTo;
      }
      if (filterValues.createDateFrom !== undefined) {
        queryParameters['createDateFrom'] = filterValues.createDateFrom;
      }
      if (filterValues.createDateTo !== undefined) {
        queryParameters['createDateTo'] = filterValues.createDateTo;
      }
      if (filterValues.brokersId !== undefined) {
        queryParameters['brokersId'] = filterValues.brokersId;
      }
      if (filterValues.productTypeIds !== undefined) {
        queryParameters['productTypeIds'] = filterValues.productTypeIds;
      }
      if (filterValues?.status !== undefined) {
        queryParameters['statusCode'] = filterValues.status;
      }
      if (filterValues?.statusIds !== undefined) {
        queryParameters['statusIds'] = filterValues.statusIds;
      }
      if (filterValues?.periodId !== undefined) {
        queryParameters['periodId'] = filterValues.periodId;
      }
      if (filterValues?.loadingDateFrom !== undefined) {
        queryParameters['loadingDateFrom'] = filterValues.loadingDateFrom;
      }
      if (filterValues?.loadingDateTo !== undefined) {
        queryParameters['loadingDateTo'] = filterValues.loadingDateTo;
      }
      if (filterValues.fiscalId !== undefined) {
        queryParameters['fiscalId'] = filterValues.fiscalId;
      }
    }
    return new HttpParams({ fromObject: queryParameters });
  }
}
